import { HortisTextLogo } from "@hortis/ui/icons/hortis-text-logo";
import type { ReactNode } from "react";

export const AuthCard = ({ children }: { children: ReactNode }) => {
  return (
    <div className="w-full flex-shrink-0 max-w-xs sm:max-w-sm shadow-none sm:shadow bg-white rounded-xl">
      <div className="flex flex-col items-center px-0 py-5 sm:px-12 sm:py-12">
        <div className="flex w-full flex-col items-center gap-8">
          <HortisTextLogo />
          {children}
        </div>
      </div>
    </div>
  );
};
